import { render, staticRenderFns } from "./createMoeda.vue?vue&type=template&id=b7647f42&scoped=true&"
import script from "./createMoeda.vue?vue&type=script&lang=js&"
export * from "./createMoeda.vue?vue&type=script&lang=js&"
import style0 from "./createMoeda.vue?vue&type=style&index=0&id=b7647f42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7647f42",
  null
  
)

export default component.exports